import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userData: null,
    progress: {},
    results: null,
    loading: false,
    error: null,
    userAnswerList: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        fetchUserStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchUserSuccess: (state, action) => {
            state.loading = false;
            state.userData = action.payload;
        },
        fetchUserFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        fetchProgressStart: (state) => {
            state.loading = true;
        },
        fetchProgressSuccess: (state, action) => {
            state.loading = false;
            state.progress = action.payload;
        },
        fetchProgressFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        fetchResultsStart: (state) => {
            state.loading = true;
        },
        fetchResultsSuccess: (state, action) => {
            state.loading = false;
            state.results = action.payload;
        },
        fetchResultsFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        fetchUserAnswerListStart: (state) => {
            state.loading = true;
        },
        fetchUserAnswerListSuccess: (state, action) => {
            state.loading = false;
            state.userAnswerList = action.payload;
        },
        fetchUserAnswerListFail: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
    },
});

export const {
    fetchUserStart,
    fetchUserSuccess,
    fetchUserFail,
    fetchProgressStart,
    fetchProgressSuccess,
    fetchProgressFail,
    fetchResultsStart,
    fetchResultsSuccess,
    fetchResultsFail,
    fetchUserAnswerListStart,
    fetchUserAnswerListSuccess,
    fetchUserAnswerListFail
} = userSlice.actions;

export default userSlice.reducer;